import React from 'react';
import Icon from '../../icon/Icon';
export var File = function(param) {
    var file = param.file, onRemove = param.onRemove, uploading = param.uploading;
    var onClick = function() {
        return onRemove(file.id);
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "file-added"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "file-name-overlay"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "file-name"
    }, file.name), !uploading && /*#__PURE__*/ React.createElement(Icon, {
        className: "file-remove",
        onClick: onClick,
        icon: "cross"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "file-progress",
        style: {
            width: "".concat(file.progress, "%")
        }
    }));
};
